@if (isCategory()) {
    <div class="flex min-w-0 items-center justify-between gap-3">
        <span class="truncate">{{ label() | translate }}</span>
        <span class="shrink-0 rounded-sm border border-base-2 px-2 py-1 text-sm text-secondary">
            {{
                'components.checkbox-tree-view-selection.selection-count'
                    | translate: { selected: selectedCount(), total: totalCount() }
            }}
        </span>
    </div>
} @else {
    <span class="block min-w-0 truncate">{{ label() | translate }}</span>
}
